var $281da683ecb6b0f9$exports = {};
$281da683ecb6b0f9$exports = {
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "notice": `\u{5D0}\u{5D6}\u{5D4}\u{5E8}\u{5D4}`,
    "positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`
};


export {$281da683ecb6b0f9$exports as default};
//# sourceMappingURL=he-IL.mjs.map
